import React from 'react'

function PrivacyEn() {
  return (
    <div className="terms">
      <div className="container pad">
        <h1 className="center">Creators Privacy Policy</h1>
        <p>The protection of your personal data is Skeepers' priority.</p>
        <p>
          The purpose of the Creators Privacy Policy (hereinafter the "Creators
          Privacy Policy") is to inform you (the <b>"Creators"</b>) of the
          processing of your personal data by Skeepers and your rights in this
          respect in the context of our collaboration.
        </p>
        <p>
          <b>"Personal data" (hereinafter "Data")</b> is to be understood as any
          information specific to you (surname, first name, age, address, email,
          telephone number, etc.).
        </p>
        <p>
          <b>"Data processing"</b> is a use of your Data, which can take any
          form (collection, recording, hosting, modification, transfer etc.).
        </p>
        <p>
          Any term specific to the protection of personal data (Data Controller,
          Data Subject etc.) is to be understood as defined in Article 4 of
          Regulation (EU) 2016/679 of the European Parliament and of the Council
          of 27 April 2016 on the protection of natural persons with regard to
          the processing of personal data and on the free movement of such data
          (known as the "General Data Protection Regulation"), hereinafter{' '}
          <b>"GDPR"</b>
          ).
        </p>
        <p>
          <b>The Creators Privacy Policy</b> applies as soon as you access the
          Skeepers site from the following URL address:{' '}
          <a target="_blank" href="https://www.octoly.com/" rel="noreferrer">
            https://www.octoly.com/
          </a>{' '}
          (the <b>"Site"</b>), it governs the use made of it, up to all the
          services offered by or in connection with the Skeepers platform (the{' '}
          <b>"Platform"</b>). The Platform is accessible to Creators who have
          registered at the following URL:{' '}
          <a
            target="_blank"
            href="https://app.im.skeepers.io/creators/sign_up"
            rel="noreferrer"
          >
            https://app.im.skeepers.io/creators/sign_up
          </a>
          .
        </p>
        <p>
          For prospects, brand customers (<b>"Brands"</b>) who have subscribed
          to the Plateforme by entering into a contract with Skeepers, as well
          as suppliers, the latter should refer to the following Privacy Policy:{' '}
          <a
            target="_blank"
            href="https://skeepers.io/fr/politique-de-confidentialite2/"
            rel="noreferrer"
          >
            https://skeepers.io/fr/politique-de-confidentialite2/
          </a>
          . Indeed, in order to offer a better visibility and understanding of
          the data collection andprocessing carried out by Skeepers, or by one
          of its subsidiaries, when delivering itsServices (here "Influencer
          Marketing")), the information of Creators and Clients is divided into
          two documents.
        </p>
        <p>
          For the purposes of this Creators Privacy Policy, all references to
          "Skeepers" or "Skeepers Group" also include its Subsidiaries (any
          entity controlled, directly or indirectly, by the Skeepers Group),
          unless otherwise stated.
        </p>
        <p>
          The Creators Privacy Policy may be modified to take into account, in
          particular, the evolution of the Data processing implemented and the
          applicable legislation. Thus, Creators are invited to read any new
          version made available by Skeepers.
        </p>
        <h2 className="fs-30">1. General information</h2>
        <p>
          By accessing and/or using the Site, the Platform and the Services in
          the aggregate, you hereby consent to all the terms of the Privacy
          Policy.
        </p>
        <p>
          Access to the Site, the Platform and the use of the Services is
          prohibited to any minor under sixteen years of age. Therefore, by
          accessing and using the Services, you represent and warrant that you
          are over the age of 16 if you are a European citizen and over the age
          of 13 if you are a U.S. citizen. If you are under the required age,
          you must not access or use the Services at any time and in any way.
        </p>
        <h2 className="fs-30">
          2. The Data Controller and the Data Subjects by this Privacy Policy
        </h2>
        <p>
          Skeepers, SAS with a capital of €11,470,723, registered with the
          Marseille Trade and Companies Register under number 879 038 990, and
          whose registered office is located at 18-20 Avenue Robert Schuman, CS
          40494, 13002 Marseille, is the owner of the https://www.octoly.com/
          website. It is composed of Solutions Ratings & Reviews, Insight and
          Feedback Management, Insight Activation, Influencer Marketing (the
          Solution used here), Live Shopping and Consumer Videos. It is
          qualified as Data Processor, as a legal entity offering Creators and
          Brands to collaborate together in order to increase the visibility
          ofBrands' products, via the Creators' accounts on social networks. It
          is a joint Data Controller with the Brands with which it collaborates.
        </p>
        <p>
          Skeepers is subject in this capacity to the obligations imposed by the
          regulations in force in France and within the European Union regarding
          personal data, in particular the General Data Protection Regulation
          known as <b>"GDPR"</b>, the French law (Data Protection Act of 1978,
          known as <b>"LiL"</b>) and, in general, with any Data Protection
          Regulations applicable to it (California Consumer Privacy Act –{' '}
          <b>CCPA</b>, California Privacy Rights Act – <b>CPRA</b>, etc.).
        </p>
        <p>
          The Persons concerned by the processing of Data are the Creators,
          including in particular Internet users browsing the Site (<b>"You"</b>
          ).
        </p>
        <h2 className="fs-30">3. Origin of the data</h2>
        <p>We may receive your Data from different sources:</p>
        <p>
          <b>From your navigation on the Site:</b> Data concerning the hardware
          and software of your computer ("fingerprinting") may be collected by
          Skeepers, unless you have expressed your objection via the cookie
          management panel and/or by configuring your web browser. This data may
          include: your IP address, browser type, domain names, dates and times
          of access and website addresses from which you accessed the Site as
          well as platform usage data (actions performed by Creators within the
          site).
        </p>
        <p>
          <b>When registering or subscribing to the Platform:</b> When you
          register or subscribe to the Platform, you must provide Skeepers with
          your email, country of residence and date of birth. Skeepers may also
          collect any anonymous, non-unique demographic information, such as
          your age or gender. You must update this data and you agree to notify
          the marketing/customer department of any changes to it without delay.
          In addition, email exchanges may be recorded and stored in order to
          improve the quality of our customer service and train our employees.
        </p>
        <p>
          <b>Access via social networks:</b> if you access or identify yourself
          on the Site and/or the Platform via a social network or any other
          service, or if you connect the Site and/or Platform to a social
          network or any other service, the information that Skeepers collects
          may also include your username or the username associated with such
          social network, any information or content that you have authorized
          the social network to share with Skeepers, such as your profile
          picture, your email address or the list of your friends, and generally
          any information that you have made public via these social networks.
          When you access the Site and/or Platform via social networks or when
          you connect the Site and/or Platform to a social network, you
          authorize Skeepers to collect, store and use this information for the
          performance of the Services.
        </p>
        <p>
          For more information on Social Media Data, see Article 6 of the
          Privacy Policy.
        </p>
        <p>
          Data will not be made public unless you share it from your Skeepers
          account.
        </p>
        <p>
          <b>
            You can connect your Skeepers account to other third-party accounts.
          </b>
          By connecting your Skeepers account to other third-party accounts via
          Application Performing Interfaces (APIs) such as Google, Youtube,
          Facebook, Twitter, TikTok or Instagram, you acknowledge and agree to
          ongoing sharing of information about yourself with other parties (in
          accordance with the privacy settings you have set on such third-party
          sites). If you do not want your Data to be shared in this way, do not
          use this feature. You may disconnect your Account from a third-party
          account at any time. You can learn how to disconnect your accounts
          from any third-party site by visiting your Account information page.
        </p>
        <p>
          The Site and/or Platform may link to sites operated by third party
          companies over which Skeepers has no control. This Privacy Policy
          applies only to information collected by Skeepers through the Site or
          Services and does not apply to such third-party sites, with any Data
          you choose to disclose to such third-party sites remaining at your
          sole risk. Skeepers does not monitor, control, or endorse the
          collection of Data or the privacy practices of third party companies.
          Skeepers encourages you to review the privacy policies of the sites
          you choose to link to to understand how those sites collect, use and
          share your information.
        </p>
        <p>
          Skeepers is not responsible for the privacy statements or any other
          content on sites other than the Site and/or the Platform.{' '}
        </p>
        <p>
          Youtube's privacy policy can be viewed at the following link:{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/"
          >
            https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/
          </a>
        </p>
        <p>
          Google's privacy policy can be found at the following link:{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="http://www.google.com/policies/privacy"
          >
            http://www.google.com/policies/privacy
          </a>
        </p>
        <p>
          Facebook's privacy policy can be found at the following link:{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://fr-fr.facebook.com/about/privacy/"
          >
            https://fr-fr.facebook.com/about/privacy/
          </a>
        </p>
        <p>
          Twitter's privacy policy can be found at the following link:{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/fr/privacy"
          >
            https://twitter.com/fr/privacy
          </a>
        </p>
        <p>
          Instagram's privacy policy can be found at the following link:{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://privacycenter.instagram.com/policy"
          >
            https://privacycenter.instagram.com/policy
          </a>
        </p>
        <p>
          TikTok's privacy policy can be found at the following link:{' '}
          <a href="https://www.tiktok.com/legal/privacy-policy-eea?lang=fr">
            https://www.tiktok.com/legal/privacy-policy-eea?lang=fr
          </a>
        </p>
        <p>
          <b>Cookies:</b> Skeepers collects data through cookies, in particular
          via the services provided by Google for the behavioral data of
          Internet users collected through the use of Cookies and/or tracers.
        </p>
        <p>
          For more information, see Article 8 of the Privacy Policy: "Use of
          Cookies/Targeted Advertising".
        </p>
        <p>
          In the event that you transmit Data relating to another person to us
          (e.g. in the context of recommendation), you guarantee us that you
          have the authority to consent to the processing of Data on his behalf,
          you receive on his behalf all correspondence relating to his Data, and
          if necessary, you consent on his behalf to the transfer of his Data
          abroad.
        </p>
        <p>
          We do not knowingly collect Data relating to minors under the age of
          13 if you are a U.S. citizen or 16 if you are a European citizen,
          however, if you are a parent or legal guardian of such minor and you
          believe that we hold Data about such minor, you may obtain the
          deletion of the Data after proving your identity and legal authority
          over the minor.
        </p>
        <h2 className="fs-30">
          4. Summary table of purposes, Data processed, basis for processing,
          storage period
        </h2>
        <p>
          The table below summarizes all Data processing by specifying for each
          purpose: the Data concerned, and the persons/services accessing this
          Data.
        </p>
        <table className="top-20 table table-striped">
          <tbody>
            <tr>
              <td valign="middle"></td>
              <td colSpan="4" valign="middle">
                <b>Data processing Creators</b>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>Context of collection</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Type of Data</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Purposes of processing</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Basis</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Person/Services with access to Data</b>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>Management of the Site and the Plateform</b>
              </td>
              <td valign="middle">
                <p>Cookies and other tracers</p>
              </td>
              <td valign="middle">
                <p>Operation of the Site and the Platform</p>
                <p>
                  General statistics on the use of the Site and the Platform
                  (audience measurements)
                </p>
                <p>Fingerprinting</p>
                <p>Deposit of Third-Party Cookies</p>
              </td>
              <td valign="middle">
                <p>Legitimate interest</p>
                <p>Consent</p>
              </td>
              <td valign="middle">
                <p>Service Marketing</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>
                  Creator relationship management (delivery of the collaboration
                  service)
                </b>
              </td>
              <td valign="middle">
                <p>
                  Mandatory (obligation indicated by an asterisk at the time of
                  collection) at the time of registration:
                </p>
                <ul>
                  <li>Email;</li>
                  <li>Localization (country);</li>
                  <li>Date of birth.</li>
                </ul>
                <p>Required (to access Consumer campaigns)</p>
                <ul>
                  <li>Name and Surname;</li>
                  <li>Genre;</li>
                  <li>Complete mailing address;</li>
                  <li>Phone number.</li>
                </ul>
                <p>Required (to access Consumer campaigns)</p>
                <ul>
                  <li>
                    Public data accessible on the account on social networks.
                  </li>
                </ul>
                <p>Not mandatory:</p>
                <ul>
                  <li>Image (and voice if Video);</li>
                  <li>Skin color;</li>
                  <li>Relational status;</li>
                  <li>Parenting;</li>
                  <li>Number of children;</li>
                  <li>Animals;</li>
                  <li>Purchasing habits;</li>
                  <li>Skin tylie/tone and concerns;</li>
                  <li>Beauty habits;</li>
                  <li>Hair color/tylie;</li>
                  <li>Household income;</li>
                  <li>Diet;</li>
                  <li>Color of the eyebrows;</li>
                  <li>Glasses;</li>
                  <li>Sizes;</li>
                  <li>Lifestyle;</li>
                  <li>Skin problems;</li>
                  <li>Favorite brands.</li>
                </ul>
              </td>
              <td valign="middle">
                <p>
                  Management of your Creator account (accessto the Creators area
                  of the Site, change of password, etc.)
                </p>
                <p>Establishment of a contract</p>
                <p>
                  Matching with campaigns based on your interests, profile and
                  social media settings
                </p>
                <p>Acceptance or rejection of your application</p>
                <p>
                  Management of the delivery of the Brand's products by Skeepers
                  or by the Brand (in the latter case, communication of your
                  email / sms to inform you of the confirmation of sending,
                  sending, delivery)
                </p>
                <p>
                  Evaluation score by the Brands according to the services you
                  have delivered
                </p>
                <p>Recording of email exchanges</p>
                <p>
                  Information emails from Skeepers (introduce you to our latest
                  features and keep you updated on our activities, etc.). You
                  can oppose their sending at any time from the unsubscribe link
                  in the email.
                </p>
                <p>
                  Available campaign emails (show you which campaigns you have
                  access to). Prior consent, you can oppose their sending at any
                  time from the unsubscribe link in the email.
                </p>
                <p>
                  Survey on the quality of service delivery. You can oppose
                  their sending at any time from the unsubscribe link in the
                  email.
                </p>
                <p>End of contract management.</p>
              </td>
              <td valign="middle">
                <p>Performance of the contract</p>
                <p>Legitimate interest</p>
                <p>Consentement</p>
              </td>
              <td valign="middle">
                <p>Sales Manager</p>
                <p>Service comptable</p>
                <p>Brands collaborating with the Creator</p>
                <p>Transport companies</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>Online order service</b>
              </td>
              <td valign="middle">
                <ul>
                  <li>Name and Surname;</li>
                  <li>Email;</li>
                  <li>Address/location;</li>
                  <li>Phone number.</li>
                </ul>
              </td>
              <td valign="middle">
                <p>Offer an online ordering service on the Site</p>
              </td>
              <td valign="middle">
                <p>Performance of the contract</p>
              </td>
              <td valign="middle">
                <p>Sales Manager</p>
                <p>Brands collaborating with the Creator</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>
                  Responses to official requests from public or judicial
                  authorities empowered for this purpose
                </b>
              </td>
              <td valign="middle">
                <p>Data set</p>
              </td>
              <td valign="middle">
                <p>
                  Transmit any data requested by public or judicial authorities
                </p>
              </td>
              <td valign="middle">
                <p>Legal obligation</p>
              </td>
              <td valign="middle">
                <p>Service comptable</p>
                <p>Legal Department</p>
                <p>Skeepers Management</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>
                  Detection, prevention and fight against fraud and cybercrime
                </b>
              </td>
              <td valign="middle">
                <p>Data set</p>
              </td>
              <td valign="middle">
                <p>
                  Collect and process payload data to detect, prevent, and fight
                  fraud and cybercrime
                </p>
              </td>
              <td valign="middle">
                <p>Legal obligation</p>
              </td>
              <td valign="middle">
                <p>Service comptable</p>
                <p>Legal Department</p>
                <p>Skeepers Management</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <b>Audit / acquisition</b>
              </td>
              <td valign="middle">
                <p>Data set</p>
              </td>
              <td valign="middle">
                <p>Audit by potential investors, buyers, buyers</p>
                <p>Controls on the proper application of our processes</p>
                <p>
                  Verification of the processing of Data from the Creators
                  database
                </p>
              </td>
              <td valign="middle">
                <p>Legitimate interest</p>
              </td>
              <td valign="middle">
                <p>Skeepers Management</p>
                <p>External service provider</p>
                <p>Potential buyer</p>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 className="fs-30">
          5. Données sensibles / “DO NOT USE MY SENSITIVE DATA” (CCPA/CPRA)
        </h2>
        <p>Sensitive data is a special category of personal data.</p>
        <p>
          This is information that reveals the alleged racial or ethnic origin,
          political opinions, religious or philosophical beliefs or trade union
          membership, as well as the processing of genetic data, biometric data
          for the purpose of uniquely identifying a natural person, data
          concerning health or data concerning a natural person's sex life or
          sexual orientation.
        </p>
        <p>
          <b>
            Skeepers offers you, through its questionnaire, to fill in sensitive
            data : your skin color (racial/ethnic origin) or your skin problems
            (potentially health data).
            <br />
            You never have to inform them. By providing this data, you expressly
            express your desire that it may serve as pre-selection elements by
            Brands in order to target specific Creators for their Campaign(s),
            only on the Platform. You can change your mind at any time by
            setting up your Creator profile.
          </b>
        </p>
        <h2 className="fs-30">6. Social media data</h2>
        <h3 className="fs-25">6.1. YouTube data</h3>
        <p>
          As a Creator, You acknowledge and agree that the Site and/or Platform
          use YouTube's API to collect and store the information and data
          available in Your YouTube account as described in YouTube's Privacy
          Policy{' '}
          <a
            target="_blank"
            href="https://www.youtube.com/howyoutubeworks/user-settings/privacy/#your-data-in-youtube"
            rel="noreferrer"
          >
            https://www.youtube.com/howyoutubeworks/user-settings/privacy/#your-data-in-youtube
          </a>{' '}
          (<b>"YouTube"</b>).
        </p>
        <p>
          YouTube Data is collected in order to (i) allow you to participate in
          YouTube Campaigns and (ii) extract statistics about your Skeepers
          activity. Your YouTube Data is stored on Skeepers servers and may be
          shared with Skeepers' preferred partners for statistical purposes.
        </p>
        <p>
          You can revoke Skeepers' access to yourYoutube Data at any time via
          Google's security settings available at the following URL:{' '}
          <a
            target="_blank"
            href="https://security.google.com/settings/security/permissions"
            rel="noreferrer"
          >
            https://security.google.com/settings/security/permissions
          </a>
          .
        </p>
        <h3 className="fs-25">6.2. Meta data (Instagram and Facebook)</h3>
        <p>
          As a Creator, You acknowledge and agree that Skeepers collects and
          stores the information and data available in your Instagram account or
          Facebook page, as the relevant assumption, as described in the Privacy
          Policy of Instagram (
          <a
            target="_blank"
            href="https://privacycenter.instagram.com/policy/?section_id=1-WhatInformationDoWe"
            rel="noreferrer"
          >
            https://privacycenter.instagram.com/policy/?section_id=1-WhatInformationDoWe
          </a>
          ) and Facebook (
          <a
            target="_blank"
            href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
            rel="noreferrer"
          >
            https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0
          </a>
          ) the <b>"Meta Data"</b>. By using the Platform, You agree to be bound
          by Meta's Privacy Policies.
        </p>
        <p>
          Meta Data is collected in order to (i) allow you to participate in
          Instagram/Facebook Campaigns and (ii) extract statistics regarding
          your Skeepers activity.
        </p>
        <p>
          Your Meta Data is stored on Skeepers servers and may be shared with
          you and Skeepers' preferred partners for the purposes of improving the
          brand-influencer relationship, improving the user experience and
          statistics.
        </p>
        <p>
          You may revoke Skeepers' access to your Meta Data at any time via the
          security settings available at the following URL:
        </p>
        <ul className="paragraph-2">
          <li>
            for Instagram:{' '}
            <a
              target="_blank"
              href="https://help.instagram.com/536741816349927/?helpref=related_articles&cms_id=536741816349927"
              rel="noreferrer"
            >
              https://help.instagram.com/536741816349927/?helpref=related_articles&cms_id=536741816349927
            </a>
          </li>
          <li>
            and for Facebook:{' '}
            <a
              target="_blank"
              href="https://www.facebook.com/help/792552774106866"
              rel="noreferrer"
            >
              https://www.facebook.com/help/792552774106866
            </a>
          </li>
        </ul>
        <h3 className="fs-25">6.3. TikTok data</h3>
        <p>
          As a Creator, You acknowledge and agree that Skeepers collects and
          stores the information and data available in your TikTok account as
          described in the TikTok Privacy Policy
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/eea/privacy-policy/en"
            rel="noreferrer"
          >
            https://www.tiktok.com/legal/page/eea/privacy-policy/en
          </a>{' '}
          (<b>"TikTok Data"</b>). By using the Platform, You agree to be bound
          by TikTok's Privacy Policy.
        </p>
        <p>
          TikTok Data is collected in order to (i) allow you to participate in
          TikTok Campaigns and (ii) extract statistics about your Skeepers
          activity.
        </p>
        <p>
          Your TikYok Data is stored on Skeepers servers and may be shared with
          you and Skeepers' preferred partners for the purpose of improving the
          brand-influencer relationship, improving the user experience and
          statistics.
        </p>
        <p>
          You may revoke Skeepers' access to your TikTok Data at any time via
          TikTok's security settings available at the following URL:
          https://support.tiktok.com/fr/account-and-privacy
        </p>
        <h2 className="fs-30">
          7. Transfert des Données / “DO NOT SHARE/SELL MY PERSONNAL DATA”
          (CCPA/CPRA)
        </h2>
        <p>
          In order to allow Skeepers to suggest Creator profiles to Customers,
          the name, age and gender of all Creators registered on the Platform
          will be automatically displayed within the Platform when creating a
          Skeepers Creator account.
        </p>
        <p>
          Skeepers may, from time to time, contact you on behalf of external
          business partners to advertise a particular offer that may be of
          interest to you. In such cases, the Data (email address, name, postal
          address, telephone number) will only be transmitted to this third
          party, including but not limited to certain information received
          through your connection to the platform of a social network, subject
          to your prior consent.
        </p>
        <p>
          In order to ensure the proper functioning of its Services, Skeepers
          uses the services of subcontractors or service providers (e.g. those
          in charge of the maintenance of the IS) such as IT service providers
          (e.g. the hosting provider), SaaS solutions that need access to Data
          to perform the mission entrusted to them by Skeepers. Skeepers imposes
          strong obligations on these contracting parties in terms of
          processing, confidentiality and security of the Data to which these
          service providers have access.
        </p>
        <p>
          Skeepers may also share Data with trusted partners to perform
          statistical analysis, send you an email or letter, provide customer
          support, or deliver products. No third party is authorized to use your
          Data, except to provide such services to Skeepers, and this ensures
          that the strict confidentiality of the Data is maintained.{' '}
        </p>
        <p>
          Skeepers may also disclose yourData to third parties in certain
          special cases:
        </p>
        <ul className="paragraph-2">
          <li>
            If Skeepers intends to divest a business or assets (including by
            divestment of the business or possessing such business), yourData
            may be disclosed to the purchaser and prospective acquirers in
            connection with an audit including their advice
          </li>
          <li>
            If any or all of Skeepers' assets are acquired by a third party, the
            Data will be one of the transferred assets. The Data will be
            processed by the acquirer who will act as the new controller and its
            data protection policy will then govern the processing of the Data
          </li>
          <li>
            If Skeepers is required to disclose or provide access to the Data to
            comply with a legal obligation or court order, or to enforce or
            enforce the performance agreement or any circumstances other than
            agreed, or to protect the rights, property, or safety of Skeepers,
            its customers, or employees
          </li>
          <li>If permitted by law by Skeepers.</li>
        </ul>
        <p>
          <b>
            You have the right to object, at any time, to the transfer of your
            data to Third Parties, who are not Service Providers used by
            Skeepers for the proper performance of the Services offered. We will
            then no longer transmit your data to these Third Parties, unless we
            can justify to you that we have legitimate and compelling reasons
            for the transfer/processing of your data that override your
            interests and your rights and freedoms, or for the establishment,
            exercise or defence of our legal claims.
            <br />
            For the sharing of data with social networks and ways to oppose it,
            refer to point 6. Network data.
            <br />
            For the deposit of cookies and the ways to oppose them, refer to
            point 8. Use of Cookies/Targeted Advertising.
            <br />
            Sale of your data, in particular the case of Reviews published on
            the Platform: by submitting your Review on the Platform, you
            authorize Skeepers to sell the information you may have provided in
            a written Review on a product you have tested, to Brands that may be
            interested. If you do not want your Review to be sold, you must
            press the "Skip" button and do not publish a Review.
            <br />
            Apart from this assumption, Skeepers does not sell your Data.
          </b>
        </p>
        <h2 className="fs-30">8. Use of Cookies/Targeted Advertising</h2>
        <p>
          Skeepers, or third parties authorized by Skeepers (such as advertisers
          or traffic analytics companies), may use tracking processes such as
          "cookies" to make your online experience as personalized as possible.
          A cookie is a set of information contained in a file deposited on your
          terminal (computer, mobile) which is read by the publisher of the
          website or mobile application, and / or by its partners, on the
          occasion of your visit or connection to our sites or mobile
          applications: this makes it possible to memorize certain data of your
          visit . Cookies cannot run programs or spread viruses on your
          computer. A cookie is uniquely assigned to you and can only be read by
          a web server in the domain that issued it. For more information on
          cookies, please visit the s website: www.allaboutcookies.org.
        </p>
        <p>
          The cookies used by Skeepers have four distinct functionalities: they
          are (1) necessary for the operation of the site or mobile application
          (including through the use of a social network), or (2) allow
          statistical analysis of the audience or (3) measure advertising
          performance.
        </p>
        <p>
          <b>1/ Cookies are necessary for the operation</b> of the site or
          mobile application: they do not require your consent, because they are
          essential: these cookies are necessary for your authentication, to
          define the language in which we distribute our content, to manage the
          technical operation of our sites and mobile applications.
        </p>
        <p>
          <b>
            2/ Social network cookies are necessary for the operation of the
            Skeepers
          </b>{' '}
          service for influencers because the registration of influencers
          requires the use of a social network (Instagram, Youtube, Facebook or
          TikTok).
        </p>
        <ul className="paragraph-2">
          <li>
            If Skeepers intends to divest a business or assets (including by
            divestment of the business or possessing such business), yourData
            may be disclosed to the purchaser and prospective acquirers in
            connection with an audit including their advice
          </li>
          <li>
            Youtube:{' '}
            <a
              target="_blank"
              href="https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/"
              rel="noreferrer"
            >
              https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/
            </a>
          </li>
          <li>
            Facebook:{' '}
            <a
              target="_blank"
              href="https://fr-fr.facebook.com/about/privacy/"
              rel="noreferrer"
            >
              https://fr-fr.facebook.com/about/privacy/
            </a>
          </li>
          <li>
            Instagram:{' '}
            <a
              target="_blank"
              href="https://privacycenter.instagram.com/policy"
              rel="noreferrer"
            >
              https://privacycenter.instagram.com/policy
            </a>
          </li>
          <li>
            TikTok:{' '}
            <a
              target="_blank"
              href="https://www.tiktok.com/legal/privacy-policy-eea?lang=fr"
              rel="noreferrer"
            >
              https://www.tiktok.com/legal/privacy-policy-eea?lang=fr
            </a>
          </li>
        </ul>
        <p>
          <b>3/ Cookies to carry out statistical analyses,</b> in order to
          understand your use of our sites and services and to improve them.
        </p>
        <p>These are cookies:</p>
        <ul className="paragraph-2">
          <li>
            Hotjar (website only):{' '}
            <a
              target="_blank"
              href="https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookie-Information"
              rel="noreferrer"
            >
              https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookie-Information
            </a>
          </li>
          <li>
            Youtube:{' '}
            <a
              target="_blank"
              href="https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/"
              rel="noreferrer"
            >
              https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/
            </a>
          </li>
          <li>
            Google Analytics (website only):{' '}
            <a
              target="_blank"
              href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
              rel="noreferrer"
            >
              https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
            </a>
          </li>
        </ul>
        <p>
          <b>4/ Cookies to measure the effectiveness of our advertising</b>
        </p>
        <p>These are cookies (only on websites):</p>
        <ul className="paragraph-2">
          <li>
            Google Tag Manager:{' '}
            <a
              target="_blank"
              href="https://developers.google.com/tag-platform/tag-manager"
              rel="noreferrer"
            >
              https://developers.google.com/tag-platform/tag-manager
            </a>
          </li>
        </ul>
        <p>
          <b>What information do we access?</b>
        </p>
        <p>We access the:</p>
        <ul className="paragraph-2">
          <li>Type of equipment you use (Android, Apple, etc.)</li>
          <li>
            Type of operating system (Microsoft Windows, Linux, Android, iOS..)
          </li>
          <li>
            Type of web browser software (Internet Explorer, Safari, Chrome,
            etc.)
          </li>
          <li>Dates and times of connection to our services</li>
          <li>
            Address of the web page from which you came before visiting our site
          </li>
          <li>Browsing data on our services</li>
          <li>Number of followers of the influencers' social network</li>
        </ul>
        <p>
          <b>What is the lifespan of cookies?</b>
        </p>
        <p>
          The cookie has a validity period limited to <b>13 months maximum</b>,
          but some cookies have a shorter lifespan.
        </p>
        <p>
          When you accept the installation and reading of cookies on your
          terminal, you accept it for a maximum of 13 months.
        </p>
        <p>
          On the other hand, when you refuse all cookies,{' '}
          <b>we may ask for your consent again after a period of 6 months</b>.
          Finally, if you continue your visit to our sites and mobile
          applications without accepting, we{' '}
          <b>may seek your consent to your next visit</b> to our sites and
          mobile applications.
        </p>
        <p>
          In any case, you have the possibility to withdraw your consent by
          going to the <b>"Consent Management"</b> link available at the bottom
          of each page of the site or in the <b>"Settings"</b> tab of your
          profile on our mobile application.
        </p>
        <p>
          You have the possibility to accept or refuse cookies by indicating
          your choice on the cookie information banner displayed when you
          connect to the Site and/or the Platform. If you refuse cookies, you
          may not be able to take full advantage of the interactive features of
          the Skeepers services or the sites you visit.
        </p>
        <p>
          You can choose to limit behavioral advertising on the Site by clicking
          on{' '}
          <a
            target="_blank"
            href="http://www.aboutads.info/choices/"
            rel="noreferrer"
          >
            http://www.aboutads.info/choices/
          </a>{' '}
          and refusing the deposit of cookies by the listed providers. After
          opting out, you will still see ads but they won't be as relevant to
          your interests. If you change your computer or browser, or delete your
          cookies, you will need to renew your refusal.
        </p>
        <h2 className="fs-30">9. Data retention period</h2>
        <p>
          The Data (in particular those relating to contracts concluded with
          Skeepers) are kept for a period of 5 years from the performance of the
          service, whether it is the performance of a service put in contact
          between Creators and Brands or for any service by a supplier. However:
        </p>
        <ul>
          <li>
            Creators' Data is kept for the duration of their activity on their
            Creator space. They will be anonymized 6 months after the closure of
            their account;
          </li>
          <li>
            Creator Data is deleted within 2 years of their last activity on
            their account;
          </li>
          <li>
            in terms of pre-litigation: the Data is kept until the conclusion of
            a settlement protocol or, failing that, until the prescription of
            the corresponding legal action;
          </li>
          <li>
            in terms of legal litigation: the Data is kept until the decision
            has the force of final res judicata.
          </li>
        </ul>
        <p>
          In general, the Data is kept only for the time necessary to achieve
          the purpose pursued at the time of their collection and in accordance
          with the recommendations of the CNIL and in compliance with legal
          obligations, including accounting and tax obligations.
        </p>
        <p>
          In addition, anonymous data and data relating to Creators may be kept
          for an unlimited period of time as long as they do not contain any
          Data.
        </p>
        <h2 className="fs-30">
          10. Data storage and security measures in place
        </h2>
        <p>
          All of your Data is hosted at Amazon Web Services in the United States
          for American Creators and within the European Union for European
          Creators (Ireland), in compliance with the rules applicable to this
          type of transfer. Apart from cases where the Creator is based abroad,
          no data is transferred to a third party located outside the European
          Union, except in the case where Skeepers must have judicial acts
          (summons, judgment, seizure...) served and / or executed abroad
          because the Creator resides outside the European Union. In this case,
          the Creator's Data is transmitted to the authorities in charge of
          serving and/or executing the acts. In any case, Skeepers ensures that
          the Data transferred is subject to adequate protection to guarantee
          its security and integrity.
        </p>
        <p>
          Your Data is only kept for the period strictly necessary for the
          purposes established in the previous articles of the Privacy Policy.
          Beyond this period, the Data is kept only for statistical and archival
          purposes, and may not be used for other purposes. Once this period has
          elapsed, your Data is destroyed.
        </p>
        <p>
          Skeepers ensures the security of your Data and takes all necessary
          precautions to ensure the confidentiality and security of your Data
          and to prevent access, use, alteration, corruption, disclosure, and/or
          destruction by unauthorized persons. and will take all necessary
          measures to limit the risk of loss, damage, or abuse.
        </p>
        <p>
          A Safety Assurance Plan and a Security Policy for Information Systems
          have been set up. For example, access to your Data is limited and
          restricted only to the persons/services who need to access it, who
          have signed a Confidentiality Agreement, this Data is stored on secure
          servers, your Data is encrypted in transit and at rest. Access to your
          Data requires the use of a strong username and password.
        </p>
        <p>
          However, the transmission of Data over the Internet is not without
          risk, and therefore Skeepers does not guarantee the security of Data
          transmitted over the Internet once Skeepers has fulfilled its security
          commitments.
        </p>
        <h2 className="fs-30">11. Your rights</h2>
        <p>
          As part of the Data processing carried out by Skeepers, you have the
          right:
        </p>
        <ul>
          <li>To obtain access / copy of your processed Data;</li>
          <li>To obtain the rectification of yourData;</li>
          <li>
            To obtain the erasure of all or part of your Data when the Data, (i)
            are no longer necessary for the purposes for which they were
            collected, (ii) are based exclusively on consent, (iii) are the
            subject of a request for opposition;
          </li>
          <li>
            To object to the processing of your Data because of your particular
            situation;
          </li>
          <li>
            To obtain the restriction of processing, temporarily, when the
            accuracy of the Data is disputed, when you have objected to the
            processing, when yourData is no longer necessary for Skeepers but is
            still necessary for the establishment, exercise or defense of legal
            claims;
          </li>
          <li>
            To unsubscribe or object to receiving marketing messages at any time
            by following the unsubscribe instructions indicated in the
            promotional emails you receive;
          </li>
          <li>
            To withdraw your consent at any time in relation to processing based
            on consent;
          </li>
          <li>
            To obtain the portability of your Data when the processing is based
            on consent and the processing is carried out using automated
            processes;
          </li>
          <li>
            To provide instructions on the fate of your post-mortem Donnée.
          </li>
        </ul>
        <p>
          For the exercise of your rights or any question relating to this
          Privacy Policy, you can send a request to the following address:{' '}
          <a href="mailto:privacy@skeepers.io">privacy@skeepers.io</a> or by
          post, to the address indicated below:
        </p>
        <p>
          SKEEPERS
          <br />
          Legal Department - Data Protection Officer
          <br />
          18-20 Avenue Robert Schuman
          <br />
          CS 40494
          <br />
          13002 Marseille
        </p>
        <p>For any request to exercise a right, you must, in your message:</p>
        <ul>
          <li>
            Specify the address (email or post) to which you wish to obtain a
            response from Skeepers;
          </li>
        </ul>
        <ul>
          <li>
            Include a means to identify you (order number, customer ID, etc. if
            the means communicated does not seem sufficient to prove your
            identity, a copy of your identity document may be required);
          </li>
          <li>
            Explain, if possible:
            <ul>
              <li>
                the context in which the collection of your data was carried out
              </li>
              <li>
                as well as the Solution concerned (Here Influencer Marketing).
              </li>
            </ul>
          </li>
        </ul>
        <p>
          This information is valuable so that the Data Protection Officer /
          Data Protection Officer can answer you as soon as possible.
        </p>
        <p>
          Skeepers informs you that no requests will be processed by telephone.
        </p>
        <p>
          A response will be sent to you as soon as possible, which may not
          exceed one (1) month from the date of receipt of your request.
        </p>
        <p>
          An extension of two (2) months is possible, in case of complex
          request, or if a large number of applications have been received.
        </p>
        <p>
          Your request, as well as any data useful for processing your request,
          will be kept for a period of three years (five years for the right to
          object) from receipt of your request. If a supporting document has
          been requested from you, or if you have sent it spontaneously, it will
          be kept for a period of one year.
        </p>
        <p>
          If you consider, after contacting the Data Protection Officer, and a
          period of one month has elapsed, that your GDPR rights are not
          respected, send a complaint to the CNIL.
        </p>
      </div>
    </div>
  )
}

export default PrivacyEn
